import * as types from './label.types';
import * as constants from './label.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeLabel = generateStoreResourceAction<types.ILabel>(constants.STORE_LABEL);
export const clearLabel = generateClearResourceAction(constants.CLEAR_LABEL);
